Apt.fn.make('properties.panel', {
	/**
	 * Initialize property panel module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		let map;

		Apt.panel.init({
			opening: () => {
				$.exec(options.opening);

				if (! map) {
					map = options.map();
				}

				if (map) {
					map.pausePosition();
				}

				if (options.sync) {
					const sync = options.sync();

					if (sync) {
						sync.pause();
					}
				}
			},
			opened: () => {
				$.exec(options.opened);
			},
			closed: () => {
				if (! map) {
					map = options.map();
				}

				if (Apt.property) {
					Apt.property.unload();
				}

				if (Apt.profile) {
					Apt.profile.unload();
				}

				if ($.screen.size() < 4 && Apt.properties.$private.activeView === 'map') {
					LS.util.crop();
				}

				if (! map) {
					return;
				}

				map.resumePosition();

				if (options.sync) {
					const sync = options.sync();

					if (sync) {
						sync.resume();
					}
				}
			}
		});

		return this;
	}
});